var _rect, _rect2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 45.25,
    width: 5,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 21.2998,
    width: 4,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 42,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,64.75H39.25v2.5H26v1.5H54v-1.5H40.75v-2.5H68A2.7528,2.7528,0,0,0,70.75,62V28A2.7528,2.7528,0,0,0,68,25.25H66.75V20A2.7528,2.7528,0,0,0,64,17.25H52A2.7528,2.7528,0,0,0,49.25,20v5.25h-4.5V12A2.7528,2.7528,0,0,0,42,9.25H16A2.7528,2.7528,0,0,0,13.25,12V25.25H12A2.7528,2.7528,0,0,0,9.25,28V62A2.7528,2.7528,0,0,0,12,64.75ZM50.75,20A1.25116,1.25116,0,0,1,52,18.75H64A1.25116,1.25116,0,0,1,65.25,20V44A1.25116,1.25116,0,0,1,64,45.25H52A1.25116,1.25116,0,0,1,50.75,44Zm-36-8A1.25116,1.25116,0,0,1,16,10.75H42A1.25116,1.25116,0,0,1,43.25,12V48A1.25116,1.25116,0,0,1,42,49.25H16A1.25116,1.25116,0,0,1,14.75,48Zm-4,16A1.25116,1.25116,0,0,1,12,26.75h1.25V48A2.7528,2.7528,0,0,0,16,50.75H42A2.7528,2.7528,0,0,0,44.75,48V26.75h4.5V44A2.7528,2.7528,0,0,0,52,46.75H64A2.7528,2.7528,0,0,0,66.75,44V26.75H68A1.25116,1.25116,0,0,1,69.25,28V57.25H10.75Zm0,30.75h58.5V62A1.25116,1.25116,0,0,1,68,63.25H12A1.25116,1.25116,0,0,1,10.75,62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevices);
export default __webpack_public_path__ + "static/media/icon_devices.8a9dd35c46cec6a5783ae27974c479d0.svg";
export { ForwardRef as ReactComponent };